import { useEffect, useState, type ReactElement } from 'react';
import { isTaskActive } from '@gr/core/platform/tasks/dto';
import { useServices, useT } from '../../../app/di';
import { useResource } from '../../../shared/hooks';
import { useObservable } from '../../../shared/store';
import { Alert } from '../../../ui-kit/Alert/Alert';
import { Loading } from '../../../ui-kit/Loading/Loading';
import { useBlog } from '../../accounts/workspaces';
import { MediaStorageReport } from './MediaStorageReport/MediaStorageReport';
import { RecompressDialog } from './RecompressDialog';

// MED-UC-8, MED-UC-9, MED-RULE-6: хранилище блога и пережатие исходников — раздел настроек владельца.
export function MediaStorageSection(): ReactElement {
  const { api, tasks } = useServices();
  const { t, te } = useT();
  const { blog } = useBlog();
  const storage = useResource(() => api.media.storage(blog.id), [api, blog.id]);
  const [recompressing, setRecompressing] = useState(false);
  const known = [...useObservable(tasks.tasks).values()].filter((task) => task.blogId === blog.id);
  const running = known.find((task) => isTaskActive(task.status)) ?? null;
  // Задача блога завершилась — объём изменился, перечитать сводку.
  const lastFinished = known.reduce((latest, task) => (task.finishedAt && task.finishedAt > latest ? task.finishedAt : latest), '');
  const { reload } = storage;
  useEffect(() => {
    if (lastFinished) void reload();
  }, [lastFinished, reload]);

  if (storage.loading && !storage.data) return <Loading label={t('common.loading')} />;
  if (storage.error || !storage.data) return <Alert tone="danger">{te(storage.error ?? [])}</Alert>;
  return (
    <>
      <MediaStorageReport storage={storage.data} busyTask={running ? { blogId: blog.id, taskId: running.id } : null} onRecompress={() => setRecompressing(true)} />
      {recompressing ? <RecompressDialog storage={storage.data} onClose={() => setRecompressing(false)} onStarted={(task) => tasks.merge([task])} /> : null}
    </>
  );
}
